export default __webpack_public_path__ + "static/media/down-arrow.600ee40a.svg";